module.exports = __webpack_public_path__ + "static/img/img03.daf39a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv045/img03.jpg
// module id = wjth
// module chunks = 0